"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeMultiSelectFieldContent = void 0;
const react_1 = __importDefault(require("react"));
const BadgeMultiSelectBadge_1 = require("../BadgeMultiSelectBadge");
require("./index.scss");
const className = 'badge-multi-select-field-content';
const BadgeMultiSelectFieldContent = (props) => {
    const { value = [], setValue, toItem, } = props;
    return (react_1.default.createElement("div", { className: className },
        value.slice(0, 2).map((item) => {
            const mappedItem = toItem(item);
            return (react_1.default.createElement(BadgeMultiSelectBadge_1.BadgeMultiSelectBadge, { key: mappedItem.value, name: mappedItem.name, onClose: () => {
                    const newSelectedValues = value.filter(x => toItem(x).value !== mappedItem.value);
                    setValue === null || setValue === void 0 ? void 0 : setValue(newSelectedValues);
                } }));
        }),
        value.length > 2 && (react_1.default.createElement("div", { className: 'badge-multi-select-badge-dots' }, "..."))));
};
exports.BadgeMultiSelectFieldContent = BadgeMultiSelectFieldContent;
//# sourceMappingURL=index.js.map